class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    document.addEventListener('click', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  positionPanel() {
    const button = this.elements.button;
    const panel = this.elements.panel;
    const buttonRect = button.getBoundingClientRect();

    panel.style.visibility = 'hidden';
    panel.removeAttribute('hidden');
    const panelHeight = panel.offsetHeight;
    panel.setAttribute('hidden', '');
    panel.style.visibility = '';

    const spaceBelow = window.innerHeight - buttonRect.bottom;
    const spaceAbove = buttonRect.top;

    if (spaceBelow >= panelHeight || spaceBelow >= spaceAbove) {
      // Open downward
      panel.style.top = `calc(100% + 10px)`;
      panel.style.bottom = 'auto';
    } else {
      // Open upward
      panel.style.bottom = `calc(100% + 10px)`;
      panel.style.top = 'auto';
    }
  }

  openSelector(event) {
    event.stopPropagation();
    const isHidden = this.elements.panel.hasAttribute('hidden');
    if (isHidden) {
      this.positionPanel();
    }
    this.elements.panel.toggleAttribute('hidden');
    const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    this.elements.button.setAttribute('aria-expanded', (!expanded).toString());
  }

  closeSelector(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);